<div id="entire_application__outlet">
	<router-outlet></router-outlet>
</div>